module.exports = __webpack_public_path__ + "0ae0fd26cf8a448f46a17b05b139307a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-3.jpg
// module id = 77
// module chunks = 0